import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useQueryClient } from "@tanstack/react-query";

import { updateWorkflowStep } from "../../../../../sevices/apiCards";
import "./ChangeStatus.scss";
import { useWorkflowById } from "../../../../../utils/reactQuery/workflows";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../../../components/Button/Button";
import useMutate from "../../../../../hooks/useMutate";
import { useMemo } from "react";

const isChangeStatus = (prevProps, nextProps) => {
  return( prevProps.currentStatusId === nextProps.currentStatusId
  && prevProps.cardId === nextProps.cardId
  && prevProps.checkCondition === nextProps.checkCondition
  && prevProps.card?.data?.data?.responseData?.board?.workflow_id === nextProps.card?.data?.data?.responseData?.board?.workflow_id
  && prevProps.card?.data?.data?.responseData?.board?.board_id === nextProps.card?.data?.data?.responseData?.board?.board_id
)
};

export default React.memo( function ChangeStatus({
  currentStatusId,
  cardId,
  checkCondition,
  card,
  boardPermission,
  currentUser
}) {
  const [status, setStatus] = React.useState('');
  const [cachedData, setCachedData] = React.useState("");
  const queryClient = useQueryClient();

  const {board_id, workflow_id} = useMemo(() => ({
    board_id: card?.data?.data?.responseData?.board?.board_id,
    workflow_id: card?.data?.data?.responseData?.board?.workflow_id,
  }), [card]);

  const { data } = useWorkflowById(workflow_id, board_id);

  React.useEffect(() => {
    if (data) {
      setCachedData(data);
    }
  }, [data]);

  React.useEffect(() => {
    setStatus(currentStatusId)
  }, [currentStatusId])

  const { mutate: updateMutate } = useMutate(updateWorkflowStep,
    ["watching", "mineCards"],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, board_id],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: ["cards", String(board_id)],
      });
      queryClient.invalidateQueries({
        queryKey: [`card`, cardId],
      });
    },
    ()=>{
      setStatus(currentStatusId)
    }
  );

  const handleChange = React.useCallback((event) => {
    const newValue = event.target.value;
    
    updateMutate({
      card_id: cardId,
      workflow_step_id: newValue,
    });
    setStatus(newValue);
  }, [cardId, updateMutate]);

  const showStatus = useMemo(() => 
    cachedData?.data?.data?.responseData?.find(
      (el) => el.workflow_step_id == currentStatusId
    ),
    [cachedData, currentStatusId]
  );
  
  const sortedWorkflowSteps = useMemo(() => {
    if (!cachedData?.data?.data?.totalRecord || !cachedData?.data?.data?.responseData){
      return [];
    }
    return cachedData.data.data.responseData
      .sort((a, b) => a.step_sequence - b.step_sequence)
      .map(el => ({
        workflow_step_id: el.workflow_step_id,
        status: el.status
      }));
  }, [cachedData]);

  return (
    <Box>
      {checkCondition  ? (
        <FormControl size="small" className="card-status-dropdown-parent">
          <Select
            labelId="demo-simple-select-label"
            value={status}
            onChange={handleChange}
            className="card-status-dropdown"
          >
            {
              sortedWorkflowSteps.map((el, index) => (
                <CustomMenuItem
                  key={`status-${el?.workflow_step_id}`}
                  className="uppercase"
                  value={el.workflow_step_id}
                >
                  {el.status}
                </CustomMenuItem>
              ))
            }
          </Select>
        </FormControl>
      ) : (
        <div className="project-status d-flex justify-content-center align-items-center">
          <button className="project-status-button">
          {showStatus && showStatus?.status}
          </button>
          <div className="project-status-icon">
            {/* <KeyboardArrowDownIcon/> */}
          </div>
        </div>
      )}
    </Box>
  );
},isChangeStatus)

